import Service, { inject as service } from "@ember/service"
import ENV from "cc-frontend/config/environment"
import type Session from "./session"

export default class GooglePickerAuth extends Service {
  declare client: any

  pickerLoaded = false
  gisInited = false
  accessToken: string | null = null
  // @ts-ignore
  tokenClient: google.accounts.oauth2.TokenClient | null = null
  promiseResolve: null | ((value: string) => void) = null
  promiseReject: null | ((value: string) => void) = null
  tokenExpiresAt: Date | null = null

  @service declare session: Session

  constructor() {
    super(...arguments)

    // load gapi
    let gapiScript = document.createElement("script")
    gapiScript.setAttribute("src", "https://apis.google.com/js/api.js")
    gapiScript.addEventListener("load", () => {
      // load the picker api
      // @ts-ignore
      window.gapi.load("picker", () => {
        this.pickerLoaded = true
      })
    })
    document.body.appendChild(gapiScript)

    // load gsi
    let gsiScript = document.createElement("script")
    gsiScript.setAttribute("src", "https://accounts.google.com/gsi/client")
    gsiScript.addEventListener("load", () => {
      // @ts-ignore
      this.tokenClient = google?.accounts?.oauth2?.initTokenClient({
        client_id: ENV.GOOGLE_DEVELOPERS_CLIENT_ID,
        scope: "https://www.googleapis.com/auth/drive.file",
        prompt: "",
        callback: async (response) => {
          if (response.error !== undefined) {
            this.promiseReject?.(response.error)
          }
          this.accessToken = response.access_token
          this.tokenExpiresAt = new Date()
          this.tokenExpiresAt.setSeconds(
            this.tokenExpiresAt.getSeconds() + Number.parseInt(response.expires_in)
          )

          this.promiseResolve?.(response.access_token)
        },
      })
      this.gisInited = true
    })
    // append gsi script to body
    document.body.appendChild(gsiScript)
  }

  requestAccessToken() {
    let isExpired = this.tokenExpiresAt !== null && this.tokenExpiresAt < new Date()

    if (this.tokenClient === null) {
      window.alert("Google Picker wasn't able to load correctly. Try refreshing the page.")
      return new Promise((resolve) => {
        // will be null
        resolve(this.accessToken)
      })
    }

    // check if no acess token or is expired
    if (this.accessToken === null || isExpired) {
      this.tokenClient?.requestAccessToken({
        prompt: "",
      })
      return new Promise((resolve, reject) => {
        this.promiseResolve = resolve
        this.promiseReject = reject
      })
    } else {
      return new Promise((resolve, reject) => {
        resolve(this.accessToken)
      })
    }
  }
}
